import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import styles from "./NotFound.module.css";

export default function NotFound() {
  return (
    <section className={styles.section}>
      <Seo
        title="Page Not Found | MIT4Doctors"
        metaTitle="Page Not Found | MIT4Doctors"
        description="The page you are looking for could not be found. Return to the MIT4Doctors homepage to explore our healthcare services."
        noindex
      />
      <div className={styles.content}>
        <div className={styles.code}>
          4<span className={styles.pulse} aria-hidden="true" />4
        </div>
        <h1>Page Not Found</h1>
        <p>
          The page you&apos;re looking for doesn&apos;t exist or may have
          been moved. Let&apos;s get you back on track.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={styles.homeLink}>
            Back to Home
          </Link>
          <Link to="/contact-us" className={styles.contactLink}>
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}
